import {
  Button,
  IconStatusCorrect,
  Text,
} from '@adc/parallax-component-library';
import { Dialog } from '@tamagui/dialog';

import { useModal } from '~/features/modals/useModal';
import { buildTestId } from '~/utils/buildTestId';

import { ModalOverlay } from '../ModalOverlay';

type IDNAddedModalProps = {
  testID: string;
  IDNId: string;
  IDNName: string;
};

export const IDNAddedModal = ({
  testID,
  IDNId,
  IDNName,
}: IDNAddedModalProps) => {
  const { closeModal } = useModal();

  const onClose = () => {
    closeModal('IDNAdded');
  };

  const handleViewIDNProfile = () => {
    console.warn('TODO: navigate to created IDN profile', { IDNId });
  };

  const handleAddAdminToIDN = () => {
    console.warn('TODO: navigate to add admin to IDN', { IDNId });
  };

  const onOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={onOpenChange} modal>
      <Dialog.Portal>
        <ModalOverlay />

        <Dialog.Content
          testID={testID}
          key="content"
          elevate
          animateOnly={['transform', 'opacity']}
          animation={[
            'quick',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}
          enterStyle={{ x: 0, y: 20, opacity: 0 }}
          exitStyle={{ x: 0, y: 10, opacity: 0, scale: 0.95 }}
          padding="$6"
          paddingBottom="$12"
          borderWidth="$0"
          maxWidth={800}
          width="100%"
          borderRadius="$1.5"
          backgroundColor="$surface.background"
          alignItems="center"
        >
          <IconStatusCorrect size="M" color="$support.positive.default" />
          <Text
            type="$h3.strong"
            testID={buildTestId({
              testID,
              suffix: 'title',
            })}
            paddingTop="$2"
          >
            IDN Added
          </Text>

          <Text type="$h4.default" color="$text.60" paddingTop="$1">
            {IDNName} has been added.
          </Text>

          <Button
            variant="secondary"
            label="Add Admin to IDN"
            onPress={handleAddAdminToIDN}
            marginTop="$8"
            // @ts-expect-error Parallax doesn't type this prop
            minWidth={256}
            testID={buildTestId({
              testID,
              suffix: ['button', 'add', 'admin', 'idn'],
            })}
          />

          <Button
            variant="secondary"
            label="View IDN Profile"
            onPress={handleViewIDNProfile}
            marginTop="$4"
            // @ts-expect-error Parallax doesn't type this prop
            minWidth={256}
            testID={buildTestId({
              testID,
              suffix: ['button', 'idn', 'profile'],
            })}
          />

          <Button
            variant="primary"
            label="Done"
            onPress={onClose}
            marginTop="$4"
            // @ts-expect-error Parallax doesn't type this prop
            minWidth={256}
            testID={buildTestId({
              testID,
              suffix: ['button', 'done'],
            })}
          />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
};
